import React from 'react';

const Header = () => {
	return (
		<header>
			<h1 className="text-center my-2">Social Buddy App</h1>
		</header>
	);
};

export default Header;
